import { useEffect, useState } from 'react';

const useDynamicFontLink = (fontName: string, fontUrl: string) => {
  // If font url is not provided, we're using one of the fonts that is already part of the package
  // as such, consider the font loaded
  const [isLoaded, setIsLoaded] = useState(!fontUrl);

  useEffect(() => {
    if (!fontUrl) return;
    const fontLinkId = `font-link-${fontName.replace(/\s+/g, '-')}`;
    const existingLink = document.getElementById(fontLinkId) as HTMLLinkElement | null;

    // If the font link already exists, no need to add it again
    if (existingLink) {
      setIsLoaded(true);
      return;
    }

    // Create a new link element
    const link = document.createElement('link');
    link.id = fontLinkId;
    link.href = fontUrl;
    link.rel = 'stylesheet';
    link.onload = () => setIsLoaded(true);
    link.onerror = () => {
      // eslint-disable-next-line no-console
      console.error(`Failed to load font: ${fontName}`);
    };
    document.head.appendChild(link);
  }, [fontName, fontUrl]);

  return isLoaded;
};

export default useDynamicFontLink;
